//打开的平台方式
export function isOpenMode(){

//平台、设备和操作系统
    const system = {
        win: false,
        mac: false,
        xll: false,
        ipad: false
    };
    //检测平台
    const p = navigator.platform;
    system.win = p.indexOf("Win")>-1;
    system.mac = p.indexOf("Mac")>-1;
    system.x11 = p === "X11" || p.indexOf("Linux") === 0;
    system.ipad = navigator.userAgent.match(/iPad/i) != null;
    //跳转语句，如果是手机访问就自动跳转到wap.baidu.com页面
    let ua = navigator.userAgent.toLowerCase();
    const isWeChat = ua.match(/MicroMessenger/gi)?Boolean(ua.match(/MicroMessenger/gi).length):false;
    if (system.win || system.mac || system.xll || system.ipad) {
        if(isWeChat) {
            //alert("在PC端微信上打开的");
            return 2;
        } else {
            //alert("在PC端非微信上打开的");
            return 3;
        }
    }
  /* 在手机端微信上打开的 */
  if(isWeChat) return 1;
  /* 在手机上非微信上打开的 */
  return 4;
}

/**
 * 判断是否移动端
 * @returns {boolean} true是移动端 false其他端
 */
const Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
const userAgentInfo = navigator.userAgent;
export const isMobile = () => Boolean(Agents.find(item=>userAgentInfo.indexOf(item)>-1));
export const isMobileSystemType = () => Agents.find(item=>userAgentInfo.indexOf(item)>-1 );